import { Market } from '@event/types';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Fade } from '@mui/material';
import { getMarketIcons } from '@event/utils';
import { useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface IEventDetailMarketCardProps {
    market: Market;
}

const EventDetailMarketCard = ({ market: { slug, title: marketName } }: IEventDetailMarketCardProps) => {
    const [showMore, setShowMore] = useState(false);
    const intl = useIntl();
    const market = useMemo(() => getMarketIcons(intl)[slug], [slug, intl]);
    const Icon = market.icon;
    return (
        <div
            style={{
                boxShadow: '0px 4px 4px 0px #0000001A',
            }}
            className="w-full h-[135px] py-2.5 px-4 flex items-start gap-6 cursor-pointer relative"
            onMouseEnter={() => setShowMore(true)}
            onMouseLeave={() => setShowMore(false)}
            onClick={() => window.open(market.url, '_blank')}
        >
            <div className="w-[40px] h-[40px]">
                <Icon className="w-full" />
            </div>
            <div
                className="flex-1 flex flex-col"
                style={{
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 5,
                }}
            >
                <p className="museo font-semibold text-base text-celestial-blue">{marketName}</p>
                <p className="h-3/4 font-inter text-xs leading-5 font-medium">{market.description}</p>
            </div>
            <Fade in={showMore}>
                <p className="absolute bottom-1 right-1 text-celestial-blue font-museo font-semibold text-xs">
                    <FormattedMessage id="common.findOutMore" defaultMessage="Find out more" />{' '}
                    <ArrowForwardIcon className="!fill-celestial-blue" sx={{ width: 18, height: 18 }} />
                </p>
            </Fade>
        </div>
    );
};

export { EventDetailMarketCard };
